import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { AuthService } from '../../../service/auth-service/auth-service.service';
import { Art57NodeList } from '../../../ui/Node/Art57Node/Art57NodeList';
import { LookupGetService } from '../../../service/lookup-service/lookup-get.service';
import { MeddraService } from '../../../service/meddra-service/meddra.service';
import { TreeNodeMeddraLevel } from '../../../ui/Node/MeddraNode/ListEntity/TreeNodeMeddraLevel';
import { MeddraNode } from '../../../ui/Node/MeddraNode/MeddraNode';
import { TreeNodeMeddraLevelItem } from '../../../ui/Node/MeddraNode/ListEntity/TreeNodeMeddraLevelItem';
import { FormlyView } from '../../../ui/Data/FormlyView';
import { QueryNode } from '../../../ui/Node/QueryNode';
import { QueryResultNode } from '../../../ui/Node/QueryResultNode';
import { ResultList } from '../../../ui/Node/ListEntity/ResultList';
import { BaseNode } from '../../../ui/Node/BaseNode';
import { QueryConditionsNode } from '../../../ui/Node/QueryConditionsNode';
import { QueryFieldsNode } from '../../../ui/Node/QueryFieldsNode';
import { SimpleSearchListNode } from '../../../ui/Node/SimpleSearchListNode';
import { CheckedManagement } from '../../../ui/CheckedManagement';
import { Util } from '../../../ui/Util';


@Component({
  selector: 'app-meddra-toolbox',
  templateUrl: './meddra-toolbox.component.html',
  styleUrl: './meddra-toolbox.component.scss'
})
export class MeddraToolboxComponent implements OnInit {
  @Input() selectedNode: any;
  @Output() buttonAction = new EventEmitter();
  supportedMeddraVersions!: any[];
  sortOrder: boolean = true;
  constructor(public authService: AuthService,
    public lookupService: LookupGetService,
    public meddraService: MeddraService,
    private injector: Injector
  ) {

  }

  ngOnInit(): void {
    this.injector.get(LookupGetService).loadCachedOptions('supportedbacklogmeddraversions').subscribe({
      next: data => {
        this.supportedMeddraVersions = data;
        this.meddraService.setVersion(this.supportedMeddraVersions[0].code);
      }
    });
  }

  onButtonAction(buttonAction: String, parameter: any) {
    switch (buttonAction) {
      case 'selectAll':
        CheckedManagement.manageItemChecked(parameter, true);
        break;
      case 'deselectAll':
        CheckedManagement.manageItemChecked(parameter, false);
        break;
      case 'sortField':
        this.sortField(parameter);
        break; 
      default:
        const data = { action: buttonAction, param: parameter };
        this.buttonAction.emit(data);
    }
  };

  showLoadButton() {
    return this.selectedNode instanceof MeddraNode &&
      this.selectedNode.data instanceof FormlyView &&
      !(this.selectedNode instanceof TreeNodeMeddraLevelItem);
  }

  showRemoveButton() {
    return this.isResultNode();
  }

  isListView() {
    return this.selectedNode instanceof Art57NodeList;
  }

  isMeddraLevelNode() {
    return this.selectedNode instanceof TreeNodeMeddraLevel;
  }

  getSupportedMeddraVersions(): any[] {
    return this.supportedMeddraVersions;
  }

  isPaginationAllowed() {
    return this.isResultNode()
  }

  isQueryResults(): boolean {
    let result = false;
    if (this.selectedNode) {
      result = this.selectedNode.showResults;
    }
    return result;
  }

  showRemoveItemsMeddraNodeButton(): boolean {
    let result = false;
    if (this.selectedNode.children && this.selectedNode.children.length > 0) {
      result = (this.isMeddraLevelNode() && !this.isQueryResults()) || this.isResultList();
    }
    return result;
  }

  showLoadAllButton(): boolean {
    return this.isResultNode() || (this.isMeddraLevelNode() && this.isQueryResults());
  }

  getStatusAllQueryResultNode(selectedNode: BaseNode, checkvalue: boolean): boolean {
    let result = false;
    if (selectedNode.data.model) {
      const arrayModel = Object.values(selectedNode.data.model);
      result = arrayModel.some((item: any) => item.checked == checkvalue);
    }

    return result;
  }

  getStatusSimpleSearchListNode(selectedNode: BaseNode, checkvalue: boolean): boolean {
    let result = false;
    if (selectedNode.data.model) {
      const arrayModel = Object.values(selectedNode.data.model);
      result = arrayModel.some((item: any) => item.checked == checkvalue);
    }

    return result;
  }

  getStatusAllFieldsNode(selectedNode: BaseNode, checkvalue: boolean): boolean {
    let result = false;

    if (selectedNode.data.model) {
      const arrayModel = Object.entries(selectedNode.data.model).map(([key, value]) => {
        return { key, value };
      });

      result = arrayModel.some((item: any) => item.value == checkvalue);
    }

    return result;
  }


  isEnabledDeselectAll(selectedNode: BaseNode): boolean {
    let atLeastOneItemChecked = false;
    if (selectedNode instanceof QueryResultNode) {
      atLeastOneItemChecked = this.getStatusAllQueryResultNode(selectedNode, true);
    } else if (selectedNode instanceof QueryFieldsNode) {
      atLeastOneItemChecked = this.getStatusAllFieldsNode(selectedNode, true);
    } else if (selectedNode instanceof SimpleSearchListNode || (selectedNode instanceof TreeNodeMeddraLevel && selectedNode.showResults)) {
      atLeastOneItemChecked = this.getStatusSimpleSearchListNode(selectedNode, true);
    } else if (selectedNode instanceof QueryConditionsNode) {
      atLeastOneItemChecked = selectedNode.data.model &&
        Object.keys(selectedNode.data.model).some(key => selectedNode.data.model[key] !== undefined && selectedNode.data.model[key] !== null && selectedNode.data.model[key] !== '');
    } else if (selectedNode instanceof MeddraNode) {
      atLeastOneItemChecked = selectedNode.children ? selectedNode.children.some(child => child.checked === true) : false;
    }

    return atLeastOneItemChecked;
  }

  isEnabledSelectAll(selectedNode: BaseNode): boolean {
    let atLeastOneItemUnchecked = false;
    if (selectedNode instanceof QueryResultNode) {
      atLeastOneItemUnchecked = this.getStatusAllQueryResultNode(selectedNode, false);
    } else if (selectedNode instanceof QueryFieldsNode) {
      atLeastOneItemUnchecked = this.getStatusAllFieldsNode(selectedNode, false);
    } else if (selectedNode instanceof SimpleSearchListNode || (selectedNode instanceof TreeNodeMeddraLevel && selectedNode.showResults)) {
      atLeastOneItemUnchecked = this.getStatusSimpleSearchListNode(selectedNode, false);
    } else if (selectedNode instanceof MeddraNode) {
      atLeastOneItemUnchecked = selectedNode.children ? selectedNode.children.some(child => child.checked === false) : false;
    }
    return atLeastOneItemUnchecked;
  }

  showSelectAllButton(): boolean {
    return this.isResultNode() ||
      this.selectedNode instanceof SimpleSearchListNode ||
      this.selectedNode instanceof QueryFieldsNode ||
      this.selectedNode instanceof TreeNodeMeddraLevel;
  }

  showDeselectAllButton(): boolean {
    return this.isResultNode() ||
      this.selectedNode instanceof SimpleSearchListNode ||
      this.selectedNode instanceof QueryFieldsNode ||
      this.selectedNode instanceof QueryConditionsNode ||
      this.selectedNode instanceof TreeNodeMeddraLevel;
  }

  isQueryNode() {
    return this.selectedNode instanceof QueryNode ||
      this.selectedNode.parent instanceof QueryNode;
  }

  isResultNode() {
    return this.selectedNode instanceof QueryResultNode;
  }

  isResultList() {
    return this.selectedNode instanceof ResultList;
  }

  showRunButton() {
    return (this.isQueryNode() && !this.isResultNode() && !this.isResultList());
  }

  showRunToExcel() {
    return (this.isQueryNode() && !this.isResultNode() && !this.isResultList());
  }

  isConditionsNode() {
    return this.selectedNode instanceof QueryConditionsNode;
  }

  showSortButton() {
    return this.selectedNode instanceof QueryFieldsNode || this.isConditionsNode();
  }

  sortField(selectedNode: BaseNode) {
    selectedNode.data.fields.sort((a:any, b:any) => {
      let labelA = a.props["label"] || '';
      let labelB = b.props["label"] || '';

      return this.sortOrder ? labelA.localeCompare(labelB) : labelB.localeCompare(labelA);
    });

    this.sortOrder = !this.sortOrder;
    selectedNode.data.fields = [...selectedNode.data.fields];
  }

  getMeddraCode(meddraCode: string): string{
    return Util.normalizeMeddra(meddraCode);
  }
}
